import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router";
import { Layout } from "./components/Layout";
import { ProfileProvider } from "./Profile";
import Loading from "./components/Loading";
import CreateLeadList from "./components/LeadCrawler/CreateLeadList";

const Home = lazy(() => import("./components/Home"));
const TerraformPlans = lazy(() => import("./components/TerraformPlans/Router"));
const LeadList = lazy(() => import("./components/LeadCrawler/LeadList"));
const AzDoGoogleChat = lazy(() => import("./components/AzDoGoogleChat"));
const Quicksight = lazy(() => import("./components/Quicksight"));

export default function App() {
  return (
    <ProfileProvider>
      <Layout>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/terraform-plans/*" element={<TerraformPlans />} />
            <Route path="/lead-list/*" element={<LeadList />} />
            <Route path="/lead-crawler/*" element={<CreateLeadList />} />
            <Route path="/azdo-googlechat/*" element={<AzDoGoogleChat />} />
            <Route path="/quicksight/*" element={<Quicksight />} />
          </Routes>
        </Suspense>
      </Layout>
    </ProfileProvider>
  );
}
